import type { NavbarHamburgerForm } from "./navbar-hamburger-form";
import type { NavbarHamburgerHandler } from "./navbar-hamburger-handler";

export class NavbarHamburgerListener {
    public form: NavbarHamburgerForm;

    public handler: NavbarHamburgerHandler;

    public constructor(form: NavbarHamburgerForm, handler: NavbarHamburgerHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.navbarHamburgerBound === "1") return;
        root.dataset.navbarHamburgerBound = "1";

        const toggle = this.form.getToggle();
        if (toggle instanceof HTMLButtonElement) {
            toggle.addEventListener("click", (event) => {
                this.handler.handleToggleClick(event);
            });
        }

        const collapsible = this.form.getCollapsible();
        if (collapsible instanceof HTMLElement) {
            collapsible.addEventListener("click", (event) => {
                this.handler.handleCollapsibleClick(event);
            });
        }

        const overlay = this.form.getOverlay();
        if (overlay instanceof HTMLElement) {
            overlay.addEventListener("click", () => {
                this.handler.handleOverlayClick();
            });
        }

        document.addEventListener("keydown", (event) => {
            this.handler.handleEscapeKey(event);
        });

        document.addEventListener(
            "click",
            (event) => {
                this.handler.handleDocumentClick(event);
            },
            true,
        );

        if (typeof globalThis.addEventListener === "function") {
            globalThis.addEventListener("resize", () => {
                this.handler.handleViewportChanged();
            });
        }
    }
}
